const NAMESPACE = '[FocusManager] ';

const FOCUSABLE_CHILDREN_NOT_FOUND = (): string => NAMESPACE + 'No focusable components were found within the provider';
const FOCUSABLE_ELEMENT_NOT_PROVIDED = (id: string): string =>
    NAMESPACE + `No focusable element provided for node "${id}"`;
const INVALID_FOCUS_ARGUMENT = (): string => NAMESPACE + '`.focus()` argument `idOrPath` is not a valid ID or path';
const NATIVE_FOCUS_MODE_NOT_SET = (): string =>
    NAMESPACE + `\`useNativeFocus\` must be enabled to provide focusable element references`;
const NO_NODE_FOUND = (id: string): string => NAMESPACE + `No focusable node found with ID "${id}"`;
const NODE_NOT_UNIQUE = (id: string): string => NAMESPACE + `ID "${id}" not unique.`;
const REACT_VERSION_UNSUPPORTED = (minVersion: string): string =>
    NAMESPACE + `Focus manager requires at least React version ${minVersion}`;
const REACT_NATIVE_VERSION_UNSUPPORTED = (minVersion: string): string =>
    NAMESPACE + `Focus manager requires at least React Native version ${minVersion}`;
const TABINDEX_NOT_PRESENT = (componentName?: string): string =>
    NAMESPACE + `Focusable component ${componentName ? `\`${componentName}\` ` : ''}is missing a \`tabIndex\` prop`;
const FOCUS_MANAGER_NOT_INJECTED = (): string =>
    NAMESPACE + 'You must inject a focus manager instance via the `focusManager` prop';
const PROP_NOT_PROVIDED = (componentName: string, propName: string): string =>
    NAMESPACE + `\`${componentName}\` components require a valid \`${propName}\` prop`;
const INVALID_NATIVE_FOCUS_OPTION = (optionName: string): string =>
    NAMESPACE + `Option \`${optionName}\` only available when \`useNativeFocus\` option set`;
const ILLEGAL_BASIS_OVERRIDE = (id: string): string =>
    NAMESPACE +
    `\`<Grid>\` with ID "${id}" may not contain any children with \`focusableBasis\` ` +
    'overrides.\n\n' +
    "A grid item's basis is always proportional to the number of columns in a row.";
const ILLEGAL_ANCHORS_OVERRIDE = (id: string): string =>
    NAMESPACE +
    `\`<Grid>\` with ID "${id}" may not contain any children with \`focusableAnchors\` ` +
    'overrides.\n\n' +
    "A grid item's anchor(s) is always aligned to the number of grid columns.";
const DEPRECATED = (name: string): string => NAMESPACE + `Usage of \`${name}\` is deprecated and no longer necessary`;
const DUPLICATE_FOCUSABLE_INDICES = (parentComponentName: string, parentId: string, index: number): string =>
    NAMESPACE +
    `\`<${parentComponentName}>\` with ID "${parentId}" contains 2 or more children ` +
    `with a \`focusableIndex\` override of \`${index}\`. Index overrides must be unique`;

export {
    FOCUSABLE_CHILDREN_NOT_FOUND,
    FOCUSABLE_ELEMENT_NOT_PROVIDED,
    FOCUS_MANAGER_NOT_INJECTED,
    INVALID_FOCUS_ARGUMENT,
    NODE_NOT_UNIQUE,
    NO_NODE_FOUND,
    NATIVE_FOCUS_MODE_NOT_SET,
    REACT_NATIVE_VERSION_UNSUPPORTED,
    REACT_VERSION_UNSUPPORTED,
    TABINDEX_NOT_PRESENT,
    PROP_NOT_PROVIDED,
    INVALID_NATIVE_FOCUS_OPTION,
    ILLEGAL_BASIS_OVERRIDE,
    ILLEGAL_ANCHORS_OVERRIDE,
    DEPRECATED,
    DUPLICATE_FOCUSABLE_INDICES,
};
